import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: auto;
  background-color: ${({ theme }) => theme.colorTokens.background.layer};
  display: flex;
  flex-direction: column;
`;

export const ParagraphWrapper = styled.div<{ hasBorderTop: boolean }>`
  padding: ${({ theme }) =>
    `${theme.space["space-3"]} ${theme.space["space-5"]}`};
  text-transform: uppercase;
  border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.subtle};
  ${({ theme, hasBorderTop }) =>
    hasBorderTop &&
    css`
      border-top: 1px solid ${theme.colorTokens.border.subtle};
    `}
`;
